<template>
  <div>
    <div class="p-4 bg-white rounded-lg shadow-md">
      <h2 class="text-lg font-semibold mb-4">Privacy Policy</h2>
      <p class="mb-4">
        This Privacy Policy ("Policy") explains how Carthike ("we", "us", or
        "our") collects, uses, and discloses your personal information when you
        use our Shopify application ("App").
      </p>
      <h3 class="text-md font-semibold mb-2">Information We Collect</h3>
      <p class="mb-4">
        When you use our App, we may collect the following types of personal
        information:
      </p>
      <ul class="list-disc pl-4 mb-4">
        <li>
          Information you provide: When you install our App, we may collect
          personal information such as your name, email address, and billing
          information.
        </li>
        <li>
          Information we collect automatically: When you use our App, we may
          automatically collect certain information about your device and usage
          of the App. This information may include your device's IP address,
          browser type, device type, and the pages or features of the App that
          you access.
        </li>
        <li>
          Information from third parties: We may also receive information about
          you from third-party sources, such as Shopify.
        </li>
      </ul>
      <h3 class="text-md font-semibold mb-2">How We Use Your Information</h3>
      <p class="mb-4">
        We may use your personal information for the following purposes:
      </p>
      <ul class="list-disc pl-4 mb-4">
        <li>To provide and maintain our App.</li>
        <li>To personalize your experience and improve the App.</li>
        <li>
          To communicate with you about the App and any updates or changes.
        </li>
        <li>To respond to your inquiries, comments, and feedback.</li>
        <li>To detect, prevent, and address technical issues.</li>
        <li>To comply with any applicable laws and regulations.</li>
      </ul>
      <h3 class="text-md font-semibold mb-2">
        How We Disclose Your Information
      </h3>
      <p class="mb-4">
        We may disclose your personal information to the following types of
        third parties:
      </p>
      <ul class="list-disc pl-4 mb-4">
        <li>
          Shopify and its service providers: We may share your personal
          information with Shopify and its service providers for the purpose of
          providing and maintaining the App.
        </li>
        <li>
          Other third parties: We may share your personal information with other
          third parties if we have your consent to do so, or if we are required
          to do so by law.
        </li>
      </ul>
      <h3 class="text-md font-semibold mb-2">Data Retention and Deletion</h3>
      <h4 class="text-md font-medium mb-2">Data Retention</h4>
      <p class="mb-4">
        We retain Personal Data only as long as necessary to provide our services or as required by applicable law.
      </p>
      <h4 class="text-md font-medium mb-2">Data Return or Deletion</h4>
      <p class="mb-4">
        Upon termination of our Agreement or your written request, we will:
      </p>
      <ul class="list-disc pl-4 mb-4">
        <li>Delete or return all Personal Data within 30 days</li>
        <li>Provide written confirmation of deletion upon request</li>
        <li>Retain data longer only if required by applicable law</li>
      </ul>
      <h3 class="text-md font-semibold mb-2">Your Choices</h3>
      <p class="mb-4">
        You may choose to restrict the collection or use of your personal
        information by not installing our App. You may also request that we
        delete your personal information by contacting us at [insert email
        address]. Please note that we may not be able to provide the App to you
        if you request that we delete your personal information.
      </p>
      <h3 class="text-md font-semibold mb-2">Security</h3>
      <p class="mb-4">
        We take reasonable measures to protect your personal information from
        unauthorized access, use, and disclosure. However, no security measure
        is perfect, and we cannot guarantee the security of your personal
        information.
      </p>
      <h3 class="text-md font-semibold mb-2">
        For processing WhatsApp messages
      </h3>
      <p class="mb-4">
        Name, Email Address, Address and order details to send Abandoned cart,
        order notifications or shipping notification messages from each of your
        orders
      </p>
      <h3 class="text-md font-semibold mb-2">
        Our service vendors where we share data to help us serve you
      </h3>
      <p class="mb-4">
        Google Analytics – to track analytics of the account
        <br />
        Firebase – To store real-time data sets
        <br />
        Mailchimp – To send update and marketing emails
        <br />
        Amazon – Cloud hosting provider
        <br />
        Mongo DB Atlas – Database hosting provider
      </p>
      <h3 class="text-md font-semibold mb-2">Changes to This Policy</h3>
      <p class="mb-4">
        We may update this Policy from time to time. If we make material changes
        to this Policy, we will notify you by email or by posting a notice on
        our website. Your continued use of the App after any changes to this
        Policy constitutes your acceptance of the changes.
      </p>
      <h3 class="text-md font-semibold mb-2">Contact Us</h3>
      <p class="mb-4">
        If you have any questions or concerns about this Policy, please contact
        us at help@carthike.com.
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
